import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';

import { FormFlex, FormBox, FormGroupAdapter, SelectStateAdapter, HideComponentsButton, ShowComponentsButton, HiddenFieldsContainer } from 'components/shared/form';

import { getName, validateRequired, getIn, composeValidators } from 'utils';
import { validateUSAZipCode } from 'utils/validates';

import styled from 'styled-components';

const propTypes = {
  areComponentsRendered: PropTypes.bool.isRequired,
  setAreComponentsRendered: PropTypes.func.isRequired,
  namespace: PropTypes.string,
  refs: PropTypes.shape({
    statesCollection: PropTypes.arrayOf(PropTypes.object),
  }),
  isRequired: PropTypes.bool,
  isFormDisabled: PropTypes.bool,
};

const defaultProps = {
  namespace: null,
  refs: {
    statesCollection: [],
  },
  isRequired: true,
  isFormDisabled: false,
};

function AddressFieldsStep2({ isFormDisabled, namespace, refs, areComponentsRendered, setAreComponentsRendered, isRequired }) {
  return (
    <Fragment>
      <FormFlex>
        {areComponentsRendered ? (
          <HideComponentsButton
            namespace={namespace}
            setAreComponentsRendered={setAreComponentsRendered}
            isRequired={isRequired}
          />
        ) : (
          <ShowComponentsButton
            setAreComponentsRendered={setAreComponentsRendered}
            namespace={namespace}
            isRequired={isRequired}
          />
        )}
      </FormFlex>

      <HiddenFieldsContainer isVisible={areComponentsRendered}>
        <FormFlex>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field
              name={getName(namespace, 'streetNumber')}
              required={isRequired}
              label="Street Number"
              disabled={isFormDisabled}
              validate={isRequired && validateRequired()}
              component={FormGroupAdapter}
            />
          </FormBox>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field
              name={getName(namespace, 'streetName')}
              required={isRequired}
              label="Street Name"
              disabled={isFormDisabled}
              validate={isRequired && validateRequired()}
              component={FormGroupAdapter}
            />
          </FormBox>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field
              name={getName(namespace, 'premise')}
              disabled={isFormDisabled}
              label="Unit/Apt #"
              component={FormGroupAdapter}
            />
          </FormBox>
        </FormFlex>

        <FormFlex>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field
              name={getName(namespace, 'municipality')}
              required={isRequired}
              label="City"
              disabled={isFormDisabled}
              validate={isRequired && validateRequired()}
              component={FormGroupAdapter}
            />
          </FormBox>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field
              name={getName(namespace, 'stateCode')}
              namespace={namespace}
              required={isRequired}
              type="select"
              isDisabled={isFormDisabled}
              options={refs.statesCollection}
              label="State"
              validate={isRequired && validateRequired()}
              component={SelectStateAdapter}
            />
          </FormBox>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field
              name={getName(namespace, 'postalCode')}
              required={isRequired}
              label="ZIP"
              disabled={isFormDisabled}
              validate={
                composeValidators(
                  isRequired ? validateRequired() : () => undefined,
                  validateUSAZipCode({ countryCodePath: getName(namespace, 'countryCode') })
                )
              }
              component={FormGroupAdapter}
            />
          </FormBox>
        </FormFlex>

        <FormFlex>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field
              name={getName(namespace, 'county')}
              disabled={isFormDisabled}
              label="County"
              component={FormGroupAdapter}
            />
          </FormBox>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field
              name={getName(namespace, 'countryCode')}
              required={isRequired}
              label="Country Code (US)"
              disabled={isFormDisabled}
              validate={isRequired && validateRequired()}
              component={FormGroupAdapter}
            />
          </FormBox>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field
              name={getName(namespace, 'countryName')}
              required={isRequired}
              label="Country Name"
              disabled={isFormDisabled}
              validate={isRequired && validateRequired()}
              component={FormGroupAdapter}
            />
          </FormBox>
        </FormFlex>
      </HiddenFieldsContainer>
    </Fragment>
  );
}

AddressFieldsStep2.propTypes = propTypes;
AddressFieldsStep2.defaultProps = defaultProps;

export default AddressFieldsStep2;
